// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"47306":"a5937532ba4fca98","97063":"d3f858184ae39089"}[chunkId] + ".css";
};